import { render, staticRenderFns } from "./CreditosRecebidos.vue?vue&type=template&id=18623980&"
import script from "./CreditosRecebidos.vue?vue&type=script&lang=js&"
export * from "./CreditosRecebidos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports